<template>
    <mst_syounin_group_search-form />
</template>

<script lang="ts">
import {defineComponent } from 'vue'
import MstSyouninGroupSearchForm from '@/components/master/syounin_group/Search.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'mst_syounin_group_search-form': MstSyouninGroupSearchForm
    }
})
</script>
